import { useGetHtmlApiQuery } from "../redux/services/apiHome";
import Loader from "../components/Loader";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
// import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";

function RtiHtmlPageByNode() {
  const { nid } = useParams();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  // const { data: rtiData = [], isLoading: rtiDataIsLoading } =
  //   useGetProtectedApiDataQuery({
  //     url: "rti",
  //     lang: languageType,
  //   });

  const { data: htmlData = {}, isLoading: htmlIsLoading } = useGetHtmlApiQuery({
    url: nid,
    lang: languageType,
  });

  const pageBody = htmlData?.body?.[0]?.value ?? "No content available";
  const pageTitle = htmlData?.title?.[0]?.value ?? "No content available";

  if (htmlIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("RTI", "आरटीआई")}
        titleLink={"/rti"}
        levelTwo={true}
        levelThree={false}
        isActive={pageTitle}
        titleTwo={pageTitle}
        // titleThree={pageTitle}
        titleLink2={`/rti/${nid}`}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <div className="row mb-5">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div dangerouslySetInnerHTML={{ __html: pageBody }}></div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default RtiHtmlPageByNode;
